import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/machine-types`)
  return data.data
}

export const useMachineTypes = () => {
  const { data, ...props } = useQuery(
    queryKeys.MACHINE_TYPES,
    () => getData(),
  )
  return { data, ...props }
}
